export const questions = [
    {
        subject: 'Математике',
        title: 'Чему равно значение числа пи (π) примерно?',
        variants: ['3.14', '2.718', '1.618', '4.669'],
        correct: 0,
    },
    {
        subject: 'Математике',
        title: 'Сколько секунд в одном часе?',
        variants: ['100', '1000', '3600', '6000'],
        correct: 2,
    },
    {
        subject: 'Математике',
        title: 'Если a = 3 и b = 4, чему равно a^2 + b^2?',
        variants: ['7', '12', '25', '48'],
        correct: 2,
    },
    {
        subject: 'Математике',
        title: 'Чему равен квадратный корень из 144?',
        variants: ['9', '12', '14', '16'],
        correct: 1,
    },
    {
        subject: 'Математике',
        title: 'Какое число является простым?',
        variants: ['12', '15', '17', '20'],
        correct: 2,
    },
    {
        subject: 'Математике',
        title: 'Сколько сторон у прямоугольника?',
        variants: ['3', '4', '5', '6'],
        correct: 1,
    },
    {
        subject: 'Математике',
        title: 'Какое число является кубом 3?',
        variants: ['6', '8', '9', '27'],
        correct: 3,
    },
    {
        subject: 'Математике',
        title: 'Чему равен sin(90°)?',
        variants: ['0', '1', '-1', '2'],
        correct: 1,
    },
    {
        subject: 'Математике',
        title: 'Сколько градусов в прямом угле?',
        variants: ['45°', '90°', '180°', '360°'],
        correct: 1,
    },
    {
        subject: 'Математике',
        title: 'Какой объем имеет куб со стороной 3 см?',
        variants: ['6 см^3', '9 см^3', '12 см^3', '27 см^3'],
        correct: 3,
    },
    {
        subject: 'Математике',
        title: 'Какое число является медианой следующего набора: 2, 5, 7, 10, 14?',
        variants: ['5', '7', '8', '10'],
        correct: 1,
    },
    {
        subject: 'Математике',
        title: 'Какое число является модой следующего набора: 2, 3, 4, 4, 5, 6, 6, 6?',
        variants: ['2', '3', '4', '6'],
        correct: 3,
    },
    {
        subject: 'Математике',
        title: 'Сколько будет 10 в степени 3?',
        variants: ['10', '100', '1000', '10000'],
        correct: 2,
    },
    {
        subject: 'Математике',
        title: 'Какое число является корнем уравнения x^2 - 4x + 4 = 0?',
        variants: ['2', '3', '4', '5'],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'Вставьте в предложение пропущенное слово: "Мы пошли в _____ магазин".',
        variants: [
            'тот',
            'тем',
            'тех',
            'та',
        ],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'Как правильно написать слово?',
        variants: [
            'в течении',
            'в течение',
            'втечение',
            'втечении',
        ],
        correct: 1,
    },
    {
        subject: 'Русскому языку',
        title: 'Найдите ошибку в образовании формы слова:',
        variants: [
            'более умный',
            'самый лучший',
            'более красивый',
            'самый умнее',
        ],
        correct: 3,
    },
    {
        subject: 'Русскому языку',
        title: 'Выберите правильное употребление предлога:',
        variants: [
            'в следствий',
            'вследствии',
            'вследствие',
            'в следствии',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'Найдите словосочетание С ошибкой:',
        variants: [
            'глубокий озеро',
            'синее небо',
            'зелёный лес',
            'высокий дом',
        ],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком слове ДОПУЩЕНА ошибка?',
        variants: [
            'внимательный',
            'облачный',
            'чюдесный',
            'молочный',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'Найдите глагол в НЕправильной форме:',
        variants: [
            'бежала',
            'прыгал',
            'шёл',
            'ездил',
        ],
        correct: 3,
    },
    {
        subject: 'Русскому языку',
        title: 'Какое слово написано НЕправильно?',
        variants: [
            'паралельный',
            'параллельный',
            'перпендикулярный',
            'горизонтальный',
        ],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'Какое слово является деепричастием?',
        variants: [
            'читающий',
            'читал',
            'читая',
            'читаем',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком предложении ЕСТЬ ошибка?',
        variants: [
            'Я не знаю, что делать.',
            'Он спросил, где я был.',
            'Она сказала, что придёт.',
            'Мы видели как она уходила.',
        ],
        correct: 3,
    },
    {
        subject: 'Русскому языку',
        title: 'Найдите глагол в НЕправильной форме:',
        variants: [
            'Клади',
            'Положи',
            'Ложи',
            'Ложись',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'Вставьте в предложение пропущенное слово: «Судя по карте, глубины в тех местах были невелики — не больше _____ метров.»',
        variants: [
            'Пятисот',
            'Пятьсот',
            'Пятиста',
            'Пятистам',
        ],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком предложении использовано олицетворение?',
        variants: [
            'Город стоял на высоком холме.',
            'Ветер со стоном метался по улице.',
            'Ее волосы, словно золото, сияли на солнце.',
            'Дерево на опушке задевало звезды.',
        ],
        correct: 1,
    },
    {
        subject: 'Русскому языку',
        title: 'Выберите верно составленное предложение:',
        variants: [
            'Он помыл уши до пояса.',
            'Он очень умный человек, но со странностями и тяжелый.',
            'Старуха Изергиль состоит из трех частей.',
            '«Я с детства немой», — сказал Герасим барыне.',
        ],
        correct: 1,
    },
    {
        subject: 'Русскому языку',
        title: 'Какая форма множественного числа у слова «дно»?',
        variants: [
            'Днища',
            'Дны',
            'Донья',
            'Дни',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'На месте каких цифр в предложении должны стоять запятые? «Мальчишки побежали в рощу (1) и (2) когда увидели там это странное зрелище (3) не испугались (4) а засмеялись.»',
        variants: [
            '2, 3, 4',
            '2, 4',
            '1, 2, 4',
            '1, 2, 3, 4',
        ],
        correct: 0,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком слове верно выделена буква, обозначающая ударный гласный звук? ',
        variants: [
            'щАвель',
            'мИзерный',
            'газопрОвод',
            'стАтуя',
        ],
        correct: 3,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком ряду в обоих словах на месте пропуска пишется буква И?',
        variants: [
            'Запомн...вшийся, пожн...шь',
            'Находивш...мся, повер...шь',
            'Слыш...мый, кле...шь',
            'Поправ...шь, исполня...мый',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'В каком варианте ответа правильно указаны все цифры, на месте которых пишется одна буква Н? «Может быть, коньки назва(1)ы коньками именно потому, что в стари(2)у делали деревя(3)ые коньки, украше(4)ые завитком в виде лошади(5)ой головы.»',
        variants: [
            '1, 2, 3, 5',
            '2, 3, 4,',
            '1, 2, 5',
            '3, 5',
        ],
        correct: 2,
    },
    {
        subject: 'Русскому языку',
        title: 'Укажите верную характеристику предложения: «Раздумывая, с горечью вспоминал этих людей, поначалу злился, обвинял, недоумевал, негодовал, а вот потом стал вспоминать самого себя.»',
        variants: [
            'Сложносочинённое',
            'Простое осложнённое',
            'Сложноподчинённое',
            'Бессоюзное сложное',
        ],
        correct: 1,
    },
    // {
    //     subject: 'Русскому языку',
    //     title: '',
    //     variants: [
    //         '',
    //         '',
    //         '',
    //         '',
    //     ],
    //     correct: ,
    // },
    {
        subject: 'Русской литературе',
        title: 'Кто из перечисленных авторов написал произведение "Преступление и наказание"?',
        variants: ['Лев Толстой', 'Иван Тургенев', 'Федор Достоевский', 'Александр Пушкин'],
        correct: 2,
    },
    {
        subject: 'Русской литературе',
        title: 'Как называется роман, в котором главным героем является капитан-круизный Пугачев?',
        variants: ['"Двенадцать стульев"', '"Капитанская дочка"', '"Буратино"', '"Капитанская смерть"'],
        correct: 3,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто из перечисленных авторов написал произведение "Мастер и Маргарита"?',
        variants: ['Лев Толстой', 'Антон Чехов', 'Михаил Булгаков', 'Иван Бунин'],
        correct: 2,
    },
    {
        subject: 'Русской литературе',
        title: 'Какое произведение является первой частью "Войны и мира" Льва Толстого?',
        variants: ['"Анна Каренина"', '"Детство"', '"Война"', '"Федороф"'],
        correct: 3,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто автор "Мертвых душ"?',
        variants: ['Лев Толстой', 'Федор Достоевский', 'Иван Тургенев', 'Николай Гоголь'],
        correct: 3,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто написал произведение "Отцы и дети"?',
        variants: ['Лев Толстой', 'Иван Тургенев', 'Федор Достоевский', 'Михаил Булгаков'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Как называется главный герой романа "Идиот" Федора Достоевского?',
        variants: ['Раскольников', 'Родион Раскольников', 'Достоевский', 'Мышкин'],
        correct: 3,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто написал повесть "Дядя Ваня"?',
        variants: ['Лев Толстой', 'Антон Чехов', 'Иван Тургенев', 'Михаил Лермонтов'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто является автором романа "Бесы"?',
        variants: ['Лев Толстой', 'Федор Достоевский', 'Иван Тургенев', 'Михаил Булгаков'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'В каком произведении Антона Чехова есть персонаж Чайка?',
        variants: ['"Вишневый сад"', '"Три сестры"', '"Чайка"', '"Дядя Ваня"'],
        correct: 0,
    },
    {
        subject: 'Русской литературе',
        title: 'Как называется произведение Михаила Лермонтова, где главный герой Чацкий?',
        variants: ['"Мцыри"', '"Герой нашего времени"', '"Бородино"', '"Полтава"'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Какой из перечисленных авторов написал роман "Анна Каренина"?',
        variants: ['Федор Достоевский', 'Лев Толстой', 'Иван Тургенев', 'Михаил Булгаков'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто написал рассказ "Каштанка"?',
        variants: ['Антон Чехов', 'Иван Тургенев', 'Лев Толстой', 'Михаил Лермонтов'],
        correct: 0,
    },
    {
        subject: 'Русской литературе',
        title: 'Какой герой романа "Обломов" Ивана Гончарова знаменит своей ленью?',
        variants: ['Обломов', 'Столыпин', 'Илья Репин', 'Алексей Николаевич'],
        correct: 0,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто из перечисленных авторов написал повесть "Капитанская дочка"?',
        variants: ['Федор Достоевский', 'Александр Пушкин', 'Иван Тургенев', 'Николай Гоголь'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Как называется роман Михаила Булгакова о временах Гражданской войны?',
        variants: ['"Белая гвардия"', '"Мастер и Маргарита"', '"Собачье сердце"', '"Идиот"'],
        correct: 0,
    },
    {
        subject: 'Русской литературе',
        title: 'Какое произведение Льва Толстого начинается фразой "Все счастливые семьи похожи друг на друга, каждая несчастливая семья несчастлива по-своему"?',
        variants: ['"Война и мир"', '"Анна Каренина"', '"Воскресение"', '"Семейное счастье"'],
        correct: 1,
    },
    {
        subject: 'Русской литературе',
        title: 'Кто является автором пьесы "Гроза"?',
        variants: ['Антон Чехов', 'Иван Тургенев', 'Лев Толстой', 'Федор Достоевский'],
        correct: 0,
    },
    {
        subject: 'Русской литературе',
        title: 'Как называется самое известное произведение Михаила Шолохова?',
        variants: ['"Тихий Дон"', '"Дон Кихот"', '"Маленький принц"', '"Мастер и Маргарита"'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'Какая страна является крупнейшей по площади в мире?',
        variants: ['Россия', 'Канада', 'США', 'Китай'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'Какое самое высокое горное образование в мире?',
        variants: ['Эверест', 'Аконкагуа', 'Килиманджаро', 'Джомолунгма'],
        correct: 3,
    },
    {
        subject: 'Географии',
        title: 'Какая река является самой длинной в мире?',
        variants: ['Амазонка', 'Нил', 'Янцзы', 'Миссисипи'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'В каком городе находится Эйфелева башня?',
        variants: ['Берлин', 'Лондон', 'Париж', 'Москва'],
        correct: 2,
    },
    {
        subject: 'Географии',
        title: 'Как называется самое крупное озеро по площади в мире?',
        variants: ['Виктория', 'Средне', 'Каспийское', 'Мичиган'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'Какое самое большое островное государство в мире?',
        variants: ['Индонезия', 'Филиппины', 'Япония', 'Новая Зеландия'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'Какое море расположено между Европой и Азией?',
        variants: ['Красное', 'Средиземное', 'Черное', 'Каспийское'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'Как называется самая большая пустыня в мире?',
        variants: ['Сахара', 'Гоби', 'Калифорнийская', 'Атакама'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'Какое самое крупное по площади государство в Южной Америке?',
        variants: ['Аргентина', 'Бразилия', 'Чили', 'Перу'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'В какой стране находится самый северный город в мире?',
        variants: ['Канада', 'Норвегия', 'Россия', 'Гренландия'],
        correct: 2,
    },
    {
        subject: 'Географии',
        title: 'Какое самое высокогорное государство в мире?',
        variants: ['Швейцария', 'Непал', 'Бутан', 'Кыргызстан'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'В какой стране находится Статуя Свободы?',
        variants: ['Франция', 'США', 'Великобритания', 'Канада'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'Какая страна имеет самое большое население в мире?',
        variants: ['Индия', 'Китай', 'США', 'Россия'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'В какой стране находятся Гималаи?',
        variants: ['Индия', 'Китай', 'Непал', 'Бутан'],
        correct: 2,
    },
    {
        subject: 'Географии',
        title: 'Какое самое большое озеро в Северной Америке?',
        variants: ['Онтарио', 'Супериор', 'Мичиган', 'Эри'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'В каком океане находится Бермудский треугольник?',
        variants: ['Тихий', 'Атлантический', 'Индийский', 'Северный Ледовитый'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'Какой самый высокий водопад в мире?',
        variants: ['Анхель', 'Ниагара', 'Виктория', 'Ангелов'],
        correct: 0,
    },
    {
        subject: 'Географии',
        title: 'В каком городе находится Петропавловская крепость?',
        variants: ['Москва', 'Петербург', 'Киев', 'Минск'],
        correct: 1,
    },
    {
        subject: 'Географии',
        title: 'Как называется самый большой океан в мире?',
        variants: ['Тихий', 'Атлантический', 'Индийский', 'Северный Ледовитый'],
        correct: 0,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым президентом США?',
        variants: ['Томас Джефферсон', 'Джордж Вашингтон', 'Джон Адамс', 'Авраам Линкольн'],
        correct: 1,
    },
    {
        subject: 'Истории',
        title: 'Кто был российским императором во время войны 1812 года?',
        variants: ['Александр II', 'Павел I', 'Александр III', 'Николай I'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Кто был фараоном во время строительства пирамиды Хеопса?',
        variants: ['Рамзес II', 'Хуфу', 'Тутмос IV', 'Сенусерт I'],
        correct: 1,
    },
    {
        subject: 'Истории',
        title: 'В каком году началась Первая мировая война?',
        variants: ['1914', '1916', '1918', '1919'],
        correct: 0,
    },
    {
        subject: 'Истории',
        title: 'Кто был основателем Российской империи?',
        variants: ['Петр I', 'Иван Грозный', 'Екатерина II', 'Александр I'],
        correct: 0,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым президентом России?',
        variants: ['Михаил Горбачёв', 'Владимир Путин', 'Борис Ельцин', 'Дмитрий Медведев'],
        correct: 2,
    },
    {
        subject: 'Истории',
        title: 'Кто победил в битве при Ватерлоо?',
        variants: ['Наполеон Бонапарт', 'Артур Уэлси', 'Александр Невский', 'Артур Дьюк Веллингтон'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым королём Египта?',
        variants: ['Клеопатра', 'Аменхотеп III', 'Тутмосис III', 'Нармер',],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым царём Великобритании?',
        variants: ['Генрих VIII', 'Эдуард III', 'Вильгельм I Завоеватель', 'Джеймс I'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'В каком году состоялась Битва при Гастингсе?',
        variants: ['1066', '1014', '1099', '1077'],
        correct: 0,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым императором Рима?',
        variants: ['Цезарь', 'Тиберий', 'Август', 'Калигула'],
        correct: 2,
    },
    {
        subject: 'Истории',
        title: 'Кто был основателем древнегреческой демократии?',
        variants: ['Солон', 'Перикл', 'Сократ', 'Клеистен'],
        correct: 1,
    },
    {
        subject: 'Истории',
        title: 'Какой русский город был столицей во времена Киевской Руси?',
        variants: ['Москва', 'Новгород', 'Псков', 'Киев'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Кто был французским революционером и лидером "Жакобинцев"?',
        variants: ['Робеспьер', 'Дантон', 'Марад', 'Миробо'],
        correct: 0,
    },
    {
        subject: 'Истории',
        title: 'Кто стал первым королём Франции?',
        variants: ['Филипп II', 'Жан II', 'Генрих IV', 'Людовик XIII'],
        correct: 2,
    },
    {
        subject: 'Истории',
        title: 'Кто был первым князем Московским?',
        variants: ['Иван Калита', 'Дмитрий Донской', 'Александр Невский', 'Юрий Долгорукий'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Какой вождь возглавил Великое восстание в Индии 1857 года?',
        variants: ['Махатма Ганди', 'Чандрагупта Маурья', 'Типу Султан', 'Мансингх'],
        correct: 3,
    },
    {
        subject: 'Истории',
        title: 'Кто был основателем династии Минг в Китае?',
        variants: ['Мао Цзэдун', 'Чжу Юаньчжан', 'Хубилай Хан', 'Чу Юаньцзя'],
        correct: 1,
    },
    {
        subject: 'Истории',
        title: 'В каком году состоялась Великая французская революция?',
        variants: ['1776', '1789', '1812', '1848'],
        correct: 1,
    },
    {
        subject: 'Истории',
        title: 'Кто был основателем династии Хан в Китае?',
        variants: ['Цинь Шихуанди', 'Чжу Юаньчжан', 'Гао Цзюань', 'Хубилай Хан'],
        correct: 0,
    },
    {
        subject: 'Физике',
        title: 'Какая из этих единиц измерения используется для измерения силы?',
        variants: ['Вольт', 'Ампер', 'Ньютон', 'Ватт'],
        correct: 2,
    },
    {
        subject: 'Физике',
        title: 'Что такое второй закон Ньютона?',
        variants: [
            'Ускорение тела пропорционально силе, действующей на него, и обратно пропорционально его массе.',
            'Сила, действующая на тело, равна произведению его массы на ускорение.',
            'Каждое действие имеет равное и противоположное действие.',
            'Скорость тела остается постоянной, пока на него не действует внешняя сила.',
        ],
        correct: 1,
    },
    {
        subject: 'Физике',
        title: 'Что такое трение?',
        variants: [
            'Сила, действующая на тело в направлении его движения.',
            'Сила, действующая на тело в противоположном направлении его движения.',
            'Сила, действующая на тело в направлении к его центру.',
            'Сила, действующая на тело, когда оно находится в покое.',
        ],
        correct: 1,
    },
    {
        subject: 'Физике',
        title: 'Что такое инерция?',
        variants: [
            'Свойство тел сохранять свое состояние покоя или равномерного прямолинейного движения.',
            'Свойство тел изменять свое движение при воздействии внешних сил.',
            'Свойство тел возвращаться в исходное состояние после деформации.',
            'Свойство тел изменять свою форму при деформации.',
        ],
        correct: 0,
    },
    {
        subject: 'Физике',
        title: 'Как называется закон сохранения энергии?',
        variants: [
            'Закон Архимеда',
            'Закон Бернулли',
            'Закон Гука',
            'Закон сохранения энергии',
        ],
        correct: 3,
    },
    {
        subject: 'Физике',
        title: 'Что такое атом?',
        variants: [
            'Самая маленькая частица вещества, состоящая из протонов, нейтронов и электронов.',
            'Самая маленькая частица вещества, состоящая из протонов и нейтронов.',
            'Самая маленькая частица вещества, состоящая из электронов и ядра.',
            'Самая маленькая частица вещества, состоящая из протонов и электронов.',
        ],
        correct: 0,
    },
    {
        subject: 'Физике',
        title: 'Как называется процесс, при котором газ превращается в жидкость?',
        variants: ['Ионизация', 'Инверсия', 'Ионный обмен', 'Конденсация'],
        correct: 3,
    },
    {
        subject: 'Физике',
        title: 'Что такое давление?',
        variants: [
            'Сила, распределенная по площади',
            'Сила, действующая на тело в направлении его движения',
            'Сила, действующая на тело в противоположном направлении его движения',
            'Сила, действующая на тело в направлении к его центру',
        ],
        correct: 0,
    },
    {
        subject: 'Физике',
        title: 'Что такое температура?',
        variants: [
            'Количество вещества, содержащееся в объекте',
            'Сила, действующая на тело в направлении его движения',
            'Величина, характеризующая тепловое состояние системы',
            'Сила, действующая на тело в противоположном направлении его движения',
        ],
        correct: 2,
    },
    {
        subject: 'Физике',
        title: 'Что такое масса?',
        variants: [
            'Сила, действующая на тело в направлении его движения',
            'Средняя кинетическая энергия частиц вещества',
            'Количественная мера инертности тела',
            'Сила, действующая на тело в противоположном направлении его движения',
        ],
        correct: 2,
    },
    {
        subject: 'Физике',
        title: 'Как называется закон сохранения импульса?',
        variants: [
            'Первый закон Ньютона',
            'Второй закон Ньютона',
            'Третий закон Ньютона',
            'Закон сохранения импульса',
        ],
        correct: 3,
    },
    {
        subject: 'Физике',
        title: 'Что такое сила тяжести?',
        variants: [
            'Сила, действующая на тело в направлении его движения',
            'Сила, действующая на тело в противоположном направлении его движения',
            'Сила, действующая на тело в направлении к его центру',
            'Сила, действующая на тело вследствие притяжения Земли',
        ],
        correct: 3,
    },
    {
        subject: 'Физике',
        title: 'Как называется закон сохранения электрического заряда?',
        variants: [
            'Закон сохранения энергии',
            'Закон сохранения импульса',
            'Закон Кулона',
            'Закон сохранения заряда',
        ],
        correct: 3,
    },
    {
        subject: 'Физике',
        title: 'Как называется элементарная частица, не имеющая заряда?',
        variants: ['Электрон', 'Протон', 'Нейтрон', 'Позитрон'],
        correct: 2,
    },
    {
        subject: 'Физике',
        title: 'Что такое электромагнитное излучение?',
        variants: [
            'Излучение, состоящее из нейтронов',
            'Излучение, состоящее из электронов',
            'Излучение, обусловленное движением зарядов',
            'Излучение, вызванное механическими колебаниями',
        ],
        correct: 2,
    },
    {
        subject: 'Физике',
        title: 'Что такое звук?',
        variants: [
            'Механические колебания среды',
            'Электромагнитные волны',
            'Излучение, состоящее из нейтронов',
            'Электромагнитное излучение',
        ],
        correct: 0,
    },
    {
        subject: 'Физике',
        title: 'Что такое амплитуда?',
        variants: [
            'Количество вещества, содержащееся в объекте',
            'Максимальное отклонение от положения равновесия в механических колебаниях',
            'Средняя кинетическая энергия частиц вещества',
            'Сила, действующая на тело в направлении его движения',
        ],
        correct: 1,
    },
    {
        subject: 'Физике',
        title: 'Что такое частота?',
        variants: [
            'Количество вещества, содержащееся в объекте',
            'Количество колебаний за единицу времени',
            'Средняя кинетическая энергия частиц вещества',
            'Сила, действующая на тело в направлении его движения',
        ],
        correct: 1,
    },
    {
        subject: 'Физике',
        title: 'Как называется закон сохранения массы?',
        variants: [
            'Закон Архимеда',
            'Закон сохранения импульса',
            'Закон сохранения энергии',
            'Закон сохранения массы',
        ],
        correct: 3,
    },
    {
        subject: 'Химии',
        title: 'Какая из перечисленных частиц составляет ядро атома?',
        variants: ['Протон', 'Электрон', 'Нейтрон', 'Нуклон'],
        correct: 3,
    },
    {
        subject: 'Химии',
        title: 'Сколько элементов в периодической системе Менделеева?',
        variants: ['108', '118', '128', '138'],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Что обозначает символ Fe в периодической системе?',
        variants: ['Железо', 'Свинец', 'Фтор', 'Фосфор'],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Что такое химический элемент?',
        variants: [
            'Вещество, состоящее из одного вида атомов',
            'Вещество, состоящее из разных видов атомов',
            'Вещество, состоящее из молекул',
            'Вещество, обладающее определенными химическими свойствами',
        ],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Как называется химическая связь, при которой атомы делят между собой электроны?',
        variants: ['Ионная связь', 'Ковалентная связь', 'Металлическая связь', 'Водородная связь'],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Что такое ион?',
        variants: [
            'Атом с равным количеством протонов и электронов',
            'Атом с отрицательным или положительным электрическим зарядом',
            'Атом, обладающий большим количеством нейтронов',
            'Атом, обладающий большим количеством протонов',
        ],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Что такое pH?',
        variants: [
            'Показатель концентрации ионов водорода в растворе',
            'Показатель концентрации ионов гидроксида в растворе',
            'Показатель концентрации ионов кислорода в растворе',
            'Показатель концентрации ионов водорода и гидроксида в растворе',
        ],
        correct: 0
    },
    {
        subject: 'Химии',
        title: 'Что такое молярная масса?',
        variants: [
            'Масса одного моля вещества в граммах',
            'Количество атомов в одном моле вещества',
            'Масса одного атома вещества в граммах',
            'Масса одного молекуля вещества в граммах',
        ],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Что такое молярный объем?',
        variants: [
            'Объем одного моля вещества',
            'Объем одного атома вещества',
            'Объем одного молекуля вещества',
            'Объем одного грамма вещества',
        ],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Что такое ионная связь?',
        variants: [
            'Химическая связь, при которой атомы делят между собой электроны',
            'Химическая связь, образующаяся между ионами с противоположными зарядами',
            'Химическая связь, образующаяся между атомами с одинаковым зарядом',
            'Химическая связь, образующаяся при совместном движении электронов',
        ],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Что такое атомный номер элемента?',
        variants: [
            'Количество протонов в ядре атома',
            'Количество нейтронов в ядре атома',
            'Количество электронов в атоме',
            'Масса атома в граммах',
        ],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Что такое химическая формула?',
        variants: [
            'Обозначение химического элемента',
            'Обозначение химического соединения',
            'Обозначение химического процесса',
            'Обозначение химической реакции',
        ],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Какая химическая формула обозначает молекулу воды?',
        variants: ['H2O2', 'CO2', 'H2O', 'CH4'],
        correct: 2,
    },
    {
        subject: 'Химии',
        title: 'Что такое химическая реакция?',
        variants: [
            'Превращение одного вида вещества в другой',
            'Смешивание вещества с растворителем',
            'Образование кристаллов вещества',
            'Образование пара вещества',
        ],
        correct: 0,
    },
    {
        subject: 'Химии',
        title: 'Что такое окислительно-восстановительная реакция?',
        variants: [
            'Реакция, при которой происходит выделение тепла',
            'Реакция, при которой происходит образование новых веществ',
            'Реакция, при которой происходит перенос электронов',
            'Реакция, при которой происходит образование кислорода',
        ],
        correct: 2,
    },
    {
        subject: 'Химии',
        title: 'Что такое кислота?',
        variants: [
            'Вещество, обладающее щелочными свойствами',
            'Вещество, обладающее кислотными свойствами',
            'Вещество, обладающее нейтральными свойствами',
            'Вещество, обладающее амфотерными свойствами',
        ],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Что такое основание?',
        variants: [
            'Вещество, обладающее кислотными свойствами',
            'Вещество, обладающее щелочными свойствами',
            'Вещество, обладающее нейтральными свойствами',
            'Вещество, обладающее амфотерными свойствами',
        ],
        correct: 1,
    },
    {
        subject: 'Химии',
        title: 'Как называется реакция, при которой из молекул воды образуется водород и кислород?',
        variants: ['Разложение', 'Синтез', 'Окисление', 'Восстановление'],
        correct: 0,
    },
    {
        subject: 'Биологии',
        title: 'Как называется наука, изучающая живые организмы?',
        variants: ['Геология', 'Физика', 'Биология', 'Химия'],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Что такое клетка?',
        variants: [
            'Молекула, образованная нуклеотидами',
            'Минимальная живая единица',
            'Органоид, содержащий генетическую информацию',
            'Структурная единица ДНК',
        ],
        correct: 1,
    },
    {
        subject: 'Биологии',
        title: 'Какие органеллы участвуют в процессе фотосинтеза?',
        variants: [
            'Лизосомы',
            'Митохондрии',
            'Хлоропласты',
            'Цитоплазма',
        ],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Как называется молекула, ответственная за наследственность?',
        variants: [
            'Протеин',
            'Углевод',
            'Липид',
            'ДНК',
        ],
        correct: 3,
    },
    {
        subject: 'Биологии',
        title: 'Что такое митоз?',
        variants: [
            'Процесс деления клетки на две дочерние клетки',
            'Процесс образования половых клеток',
            'Процесс слияния двух клеток',
            'Процесс образования клеточных органелл',
        ],
        correct: 0,
    },
    {
        subject: 'Биологии',
        title: 'Как называется процесс, при котором клетка получает энергию из глюкозы?',
        variants: [
            'Фотосинтез',
            'Гликолиз',
            'Дыхание клетки',
            'Транскрипция',
        ],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Какое из перечисленных веществ является основным строительным материалом клеток?',
        variants: [
            'Протеин',
            'Углевод',
            'Липид',
            'Нуклеиновая кислота',
        ],
        correct: 0,
    },
    {
        subject: 'Биологии',
        title: 'Что такое экосистема?',
        variants: [
            'Совокупность однородных биотопов',
            'Совокупность популяций всех видов, населяющих данный биотоп',
            'Совокупность всех видов в пределах определенной территории',
            'Совокупность популяций одного вида',
        ],
        correct: 1,
    },
    {
        subject: 'Биологии',
        title: 'Что такое биом?',
        variants: [
            'Совокупность популяций одного вида',
            'Совокупность биотопов',
            'Совокупность всех видов в пределах определенной территории',
            'Совокупность популяций всех видов, населяющих данный биотоп',
        ],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Что такое мутация?',
        variants: [
            'Изменение последовательности нуклеотидов в ДНК',
            'Изменение последовательности аминокислот в белке',
            'Изменение последовательности молекул в ДНК',
            'Изменение последовательности атомов в молекуле',
        ],
        correct: 0,
    },
    {
        subject: 'Биологии',
        title: 'Что такое адаптация?',
        variants: [
            'Изменение генетического материала',
            'Изменение структуры организма в процессе его развития',
            'Приспособление организма к условиям окружающей среды',
            'Изменение окружающей среды',
        ],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Что такое фотосинтез?',
        variants: [
            'Процесс, при котором клетка получает энергию из глюкозы',
            'Процесс деления клетки на две дочерние клетки',
            'Процесс, при котором клетка выделяет энергию из глюкозы',
            'Процесс, при котором растения преобразуют световую энергию в химическую',
        ],
        correct: 3,
    },
    {
        subject: 'Биологии',
        title: 'Что такое биологическая ниша?',
        variants: [
            'Место, где обитает популяция одного вида',
            'Роль и место в экосистеме',
            'Суммарное пространство, занимаемое всеми видами в пределах определенной территории',
            'Поведение организма в процессе поиска пищи',
        ],
        correct: 1,
    },
    {
        subject: 'Биологии',
        title: 'Что такое топосистема?',
        variants: [
            'Совокупность биотопов',
            'Совокупность популяций одного вида',
            'Совокупность всех видов в пределах определенной территории',
            'Совокупность всех видов, населяющих данный биотоп',
        ],
        correct: 0,
    },
    {
        subject: 'Биологии',
        title: 'Как называется процесс, при котором растения получают воду из почвы?',
        variants: [
            'Дыхание',
            'Фотосинтез',
            'Транспирация',
            'Ассимиляция',
        ],
        correct: 2,
    },
    {
        subject: 'Биологии',
        title: 'Что такое антропогенное воздействие на окружающую среду?',
        variants: [
            'Воздействие природных факторов на организм',
            'Воздействие человека на природу',
            'Воздействие организмов на окружающую среду',
            'Воздействие окружающей среды на организмы',
        ],
        correct: 1,
    },
    {
        subject: 'Биологии',
        title: 'Что такое генетический код?',
        variants: [
            'Уникальный набор генов организма',
            'Последовательность аминокислот в белке',
            'Уникальная последовательность нуклеотидов в ДНК',
            'Уникальная последовательность атомов в молекуле',
        ],
        correct: 2,
    }
]